import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import SubHeader from "../../../fragments/SubHeader";
import BreadCrumbContainer from "../../../fragments/BreadCrumbContainer";
import BreadCrumb from "../../../fragments/BreadCrumb";

const SubHeaderMisCompras = () => {
  const navigate = useNavigate();
  return (
    <SubHeader>
      <BreadCrumbContainer>
        <BreadCrumb route={"Inicio /"} onClick={() => navigate(`/home`)} />
        <BreadCrumb route={"Mis compras"} active />
      </BreadCrumbContainer>
    </SubHeader>
  )
};

export default SubHeaderMisCompras;
